import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/shared/styles/design-system.css';
import App from '@/app/App';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '@/shared/api/firebase';

// ── Global Error Logger to Firestore (AI Self-Healing pipeline) ─────
const logSystemError = async (message: string, stack: string, moduleName: string = 'App Global') => {
  // Prevent logging loop if Firestore write fails
  if (message.includes('Failed to log error to Firestore')) return;

  try {
    const colRef = collection(db, 'system_errors');
    await addDoc(colRef, {
      module: moduleName,
      message: message,
      trace: stack,
      resolved: false,
      createdAt: new Date(),
    });
    console.log('🤖 [IA Self-Healing] Excepción registrada en Firestore.');
  } catch (err) {
    console.error('Failed to log error to Firestore:', err);
  }
};

// 1. Intercept standard uncaught exceptions
window.addEventListener('error', (event) => {
  const errorMsg = event.message || event.error?.message || 'Error no controlado';
  const stackTrace = event.error?.stack || 'No stack trace available';
  
  let filename = 'App Global';
  if (event.filename) {
    const parts = event.filename.split('/');
    filename = parts[parts.length - 1] || 'App Global';
  }

  logSystemError(errorMsg, stackTrace, filename);
});

// 2. Intercept unhandled Promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const errorMsg = reason?.message || String(reason) || 'Promesa rechazada no controlada';
  const stackTrace = reason?.stack || 'No stack trace available';
  
  logSystemError(errorMsg, stackTrace, 'Promise Rejection');
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
